<ng-template #content>
  <ng-content></ng-content>
</ng-template>
<span *ngIf="enableNavigation" [capHistinfo]="histinfo">
  <a class="linkAsText" container="body" [routerLink]="path" [queryParams]="enrichedQueryParams"
     [target]="openInNewTab ? '_blank' : '_self'"
     [ngbTooltip]="tooltip|translate:tooltipParams"
     [placement]="placement">
        <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</span>
<span *ngIf="!enableNavigation" [capHistinfo]="histinfo">
    <ng-container *ngTemplateOutlet="content"></ng-container>
</span>
